// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qZyN","question":"styles_question__3bsyx","description":"styles_description__2a71w"};